export class Lagerplatz {
    public lagerplatz: string;
    public bezeichnung: string;
}



// WEBPACK FOOTER //
// ./src/providers/rest-server/data/Lagerplatz.ts